import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'PropertyCardImage',
    props: ['property', 'showStreetView', 'staticMapData', 'theme', 'previewPhoto', 'cardParent', 'preload'],
    inject: ['$eventBus'],
    components: {
        mvtMapStatic,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        isPreload() {
            return this.preload;
        },
        photoUrl() {
            if (this.cardParent === 'carousel' && this.getSplit('movoto-property-carousel-image-CW-4295')) {
                return this.property.tnImgPath?.replace(/(_t|_p)\.(jpeg|webp)$/, '_m.jpeg');
            }
            return this.property.tnImgPath;
        },
    },
    data() {
        return {
            index: 0,
            photoUrls: [],
            loaded: false,
            animationName: '',
            initaledDrag: false,
            hoverTimer: null,
            sensitivity: 20,
            buffer: 2,
            timer: null,
        };
    },
    methods: {
        ...mapActions('glb', ['getDppPhotoByUrl']),
        onClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.emitOpenDpp();
        },
        emitOpenDpp() {
            this.$emit('openDpp');
        },
    },
};
